import React, { useState } from 'react';

const NotificationBell = ({ notifications, onMarkAllRead }) => {
  const [open, setOpen] = useState(false);
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="relative">
      <button
        className="relative focus:outline-none hover:scale-110 transition-transform"
        onClick={() => setOpen(!open)}
        aria-label="Notifications"
      >
        <span className="inline-block text-2xl">🔔</span>
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 animate-pulse">
            {unreadCount}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white shadow-lg rounded-lg z-50 p-4">
          <div className="flex justify-between items-center mb-2">
            <span className="font-semibold">Notifications</span>
            <button className="text-xs text-primary-600 hover:underline" onClick={onMarkAllRead}>Mark all as read</button>
          </div>
          <ul className="max-h-64 overflow-y-auto">
            {notifications.length === 0 ? (
              <li className="text-gray-500 text-sm">No notifications yet.</li>
            ) : (
              notifications.map((n, i) => (
                <li key={i} className={`mb-2 p-2 rounded ${n.read ? 'bg-gray-50' : 'bg-primary-50'}`}>
                  <span className="block text-sm">{n.message}</span>
                  <span className="block text-xs text-gray-400 mt-1">{n.time}</span>
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default NotificationBell; 